import { Issue } from "../issue/classes";
import { Address } from "../location/classes";

export class Contact {
    contactpersid: number = null;
    contactpersfname: string = null;
    contactperslname: string = null;
    contactperssalutation: string = null;
    contactperspublicid: string = null;
    contactpersondepartment: string = null;
    contactpersinfo: string = null;
    contactpersmail: string = null;
    contactpersphone: string = null;
    contactpersaddress: number = null;
    address: Address = null;
    contactinformation: ContactInformation[] = [];
    customer: Customer[] = null;
    concurrencystamp: string = null;
}

export class ContactInformation {
    infoid: number = null;
    infotype: number = null;
    infovalue: string = null;
    infocpers: number = null;
    contactinformationtype: ContactInformationType = null;
}

export class ContactInformationType {
    typeid: number;
    typename: string;
    typedesc: string;
    icon: string;
}

export class Customer {
    customerid: number = null;
    customernumber: string = null;
    customername: string = null;
    customerphone: string = null;
    customerfax: string = null;
    customermail: string = null;
    customernote: string = null;
    customeraddress: number = null;
    concurrencystamp: string = null;
    customeractive: boolean = true;
    address: Address;
    issues: Issue[];
    contactpersonal: Contact[];
}
